import React, { useEffect, useReducer, useState } from "react";
import { Pencil, GitMerge, CircleX, CircleCheck } from "lucide-react";
import useIntl from "../../common/lang/locale/en-US";
import useLeadershipData from "../../screens/preliminarystaffing/viewproject/hooks/useLeadershipData";
import { useAxiosContext } from "../../context/axiosinstance";
import ComboBox from "@/components/ui/combobox";
import { saveData } from "@screens/preliminarystaffing/viewproject";
import {
  actionNameConfig,
  SocketIdType,
} from "@configure/menuAndSubmenuConfig";
import { useLocation } from "react-router-dom";
function reducer(state, action) {
  switch (action.type) {
    case "RESET":
      return init(action.payload);
    case "SET_DELIVERY_MANAGER":
      return { ...state, "Delivery Manager": action.payload };
    case "SET_DEAL_REVIEW_PREPARER":
      return { ...state, "Deal Review Preparer": action.payload };
    default:
      return state;
  }
}

const init = ({ data: initialArg, leaderShipResources }) => {
  return {
    Collaborator: {
      label: initialArg?.additionalInfo[0]?.value,
      employeeid: "NA",
    },
    "Practice Lead": {
      label: initialArg?.additionalInfo[1]?.value,
      employeeid: "NA",
    },
    "Engagement Manager": {
      label: initialArg?.additionalInfo[2]?.value,
      employeeid: "NA",
    },
    "Delivery Manager": {
      label: initialArg?.additionalInfo[3]?.value,
      employeeid:
        leaderShipResources
          ?.find((resource) =>
            initialArg?.additionalInfo[3]?.value === resource.fullname
          )
          ?.employeeid || "NA",
    },
    "Deal Review Preparer": {
      label: initialArg?.additionalInfo[4]?.value,
      employeeid:
        leaderShipResources
          ?.filter((resource) =>
            initialArg?.additionalInfo[4]?.value.includes(resource.fullname)
          )
          ?.map((resource) => resource.employeeid) || "NA",
    },
    "Buying Process": {
      label: initialArg?.additionalInfo[5]?.value,
      employeeid: "NA",
    },
    "Contract Type": {
      label: initialArg?.additionalInfo[6]?.value,
      employeeid: "NA",
    },
    "Forecast Category": {
      label: initialArg?.additionalInfo[7]?.value,
      employeeid: "NA",
    },
  };
};

const possibleModules = {
  "/scoped-dashboard": "scoped",
  "/deal-review-dashboard": "dealreview",
};

// Individual item component for the grid layout
const AdditionalInfoItem = ({ item, index, state, dispatch, resources, isAuthenticated, projectid, deal_id, getData, initialRequest, isSubmitting }) => {
  const { isButtonDisabled } = useAxiosContext();
  const [showMoreIndexes, setShowMoreIndexes] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const pathname = useLocation().pathname;

  const moduleName =
    Object.entries(possibleModules).find(([key]) =>
      pathname.startsWith(key)
    )?.[1] || null;

  const handleEdit = () => {
    setEditMode(true);
  };

  const handleSave = async () => {
    const saveDetails = {
      additional_info: {
        hs_deal_id: deal_id,
        delivery_manager: state["Delivery Manager"].employeeid || "NA",
        deal_review_preparer:
          state["Deal Review Preparer"].employeeid.join(";") || "NA",
      },
      projectid: projectid,
      module: moduleName,
    };
    setEditMode(false);
    await saveData(saveDetails, projectid, {
      "Socket-Action":
        moduleName === "dealreview"
          ? actionNameConfig.DEALREVIEW.ADDITIONAL_INFO_UPDATION_IN_DEALREVIEW
          : actionNameConfig.SCOPED.ADDITIONAL_INFO_UPDATION_IN_SCOPED,
      "Socket-Deal-Id": projectid,
      "Socket-Id-Type": SocketIdType.ProjectId,
      "Socket-Deal-Status": null,
    });
    await getData(false);
  };

  const toggleShowMore = () => {
    setShowMoreIndexes((prev) => !prev);
  };

  const handleChange = (newValue) => {
    if (Array.isArray(newValue)) {
      const label = newValue;
      const employeeid = resources
        .filter((resource) => newValue.includes(resource.fullname))
        .map((item) => item.employeeid);
      dispatch({
        type: "SET_DEAL_REVIEW_PREPARER",
        payload: { label, employeeid: employeeid },
      });
      return;
    }
    const label = newValue;
    const employeeid =
      resources.find((resource) => resource.fullname === newValue)
        ?.employeeid || "NA";
    dispatch({ type: "SET_DELIVERY_MANAGER", payload: { label, employeeid } });
  };

  const handleCancel = () => {
    dispatch(initialRequest);
    setEditMode(false);
  }

  const value = item?.multiple ? state?.[item?.subLabel]?.label?.filter(v => Boolean(v?.trim())) || [] : state?.[item?.subLabel]?.label?.trim() || "";

  console.log(editMode, item.type)
  return (
    <div className="group space-y-1">
      <div className="flex items-start justify-between gap-2">
        <p className="text-xs text-muted-foreground">{item.subLabel}</p>
        <div className="flex items-center gap-1">
          {item.type === "edit" && isAuthenticated ? (
            editMode ? (
              <>
                <CircleCheck
                  className="h-4 w-4 text-onshore cursor-pointer aria-disabled:text-muted-foreground/20"
                  onClick={async () => await handleSave()}
                  aria-disabled={isButtonDisabled || isSubmitting}
                  role="button"
                />
                <CircleX
                  className="h-4 w-4 cursor-pointer text-muted-foreground aria-disabled:text-muted-foreground/20"
                  onClick={handleCancel} 
                  role="button"
                  aria-disabled={isButtonDisabled || isSubmitting}
                  />
              </>
            ) : (
              <span
                className="w-[18.75px] h-[18.75px] cursor-pointer"
                onClick={(!isButtonDisabled && !isSubmitting) ? handleEdit : undefined}
                role="button"
              >
                <Pencil aria-disabled={isButtonDisabled || isSubmitting} className="h-4 w-4 text-muted-foreground hover:text-foreground  aria-disabled:text-muted-foreground/20" />
              </span>
            )
          ) :
            <GitMerge className="h-3 w-3 text-muted-foreground" />
          }
        </div>
      </div>

      <div className="space-y-1">
        {editMode ? (
          <ComboBox
            id={`addInfo-select-${index}`}
            name="fullname"
            multiselect={item.multiple}
            options={resources.map((resource) => resource.fullname)}
            value={value}
            onChange={(value) => handleChange(value)}
            disabled={item.disabled}
            placeholder={
              Array.isArray(state[item.subLabel].label)
                ? state[item.subLabel].label.join(", ")
                : state[item.subLabel].label
            }
          />
        ) : Array.isArray(state[item.subLabel].label) ? (
          <div className="flex flex-col gap-1">
            <p className="font-medium text-foreground text-sm pr-2">
              {state[item.subLabel].label.length === 0 ||
                state[item.subLabel].label.every((label) => label.trim() === "")
                ? "NA"
                : showMoreIndexes
                  ? state[item.subLabel].label.join(", ")
                  : state[item.subLabel].label.slice(0, 3).join(", ")}
            </p>
            {state[item.subLabel].label.length > 3 && (
              <button
                className="text-xs text-primary hover:underline cursor-pointer text-left"
                onClick={() => toggleShowMore()}
              >
                {showMoreIndexes
                  ? "Show less"
                  : `+ ${state[item.subLabel].label.length - 3} more`}
              </button>
            )}
          </div>
        ) : (
          <p className="font-medium text-foreground text-sm pr-2">
            {!state[item.subLabel].label ||
              state[item.subLabel].label.trim() === ""
              ? "NA"
              : state[item.subLabel].label}
          </p>
        )}
      </div>
    </div>
  );
};

export function AdditionalInformation({
  data,
  className = "",
  isLoading = false,
  isAuthenticated = false,
  isSubmitting = false,
  projectid,
  getData = () => { }
}) {
  const { leaderShipResources = [] } = useLeadershipData();

  // create useReducer State to set the employeeid for delivery manager and deal review preparer
  const [state, dispatch] = useReducer(reducer, { data, leaderShipResources }, init);

 const initialRequest = {
  type: "RESET",
  payload: { data, leaderShipResources }
}

  useEffect(() => {
    dispatch(initialRequest);
  }, [JSON.stringify(leaderShipResources + ''), JSON.stringify(data + '')]);
  if (isLoading) {
    return (
      <div className={`2 w-full ${className}`}>
        <div className="border border-border rounded-lg overflow-hidden bg-card">
          <div className="px-4 py-3 border-b bg-muted/30">
            <div className="h-4 w-32 bg-muted animate-pulse rounded"></div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 p-4">
            {Array.from({ length: 8 }).map((_, index) => (
              <div key={index} className="space-y-2">
                <div className="h-3 w-20 bg-muted animate-pulse rounded"></div>
                <div className="h-4 w-24 bg-muted animate-pulse rounded"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`mb-2 w-full ${className}`}>
      <div className="border border-border rounded-lg overflow-hidden bg-card">
        <div className="px-4 py-3 border-b bg-muted/30">
          <h3 className="text-sm font-semibold text-foreground">
            {useIntl["addtional_information"] || "Additional Information"}
          </h3>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 p-4">
          {(data?.additionalInfo ?? []).map((item, index) => (
            <AdditionalInfoItem
              key={index}
              item={item}
              index={index}
              state={state}
              dispatch={dispatch}
              resources={leaderShipResources}
              isAuthenticated={isAuthenticated}
              isSubmitting={isSubmitting}
              projectid={projectid}
              deal_id={data?.hs_deal_id}
              getData={getData}
              initialRequest={initialRequest}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default AdditionalInformation;
